import { Card, CardProps, Col, Row, Skeleton } from "antd"

const HotelGoodPriceItemSkeleton = (props: CardProps) => {

  return (
    <Card
      hoverable
      cover={(
        <Skeleton.Image
          active
          style={{ height: "200px", objectFit: "cover", width: '100%' }}
          styles={{
            root: {
              width: '100%'
            }
          }}
        />
      )}
      style={{
        minHeight: '100%',
        width: '100%'
      }}
      styles={{
        ...props.styles,
        body: {
          padding: "1.2rem",
          display: "flex",
          flexDirection: "column",
          height: 'calc(100% - 200px)',
          ...(props.styles as any)?.body,
        },
      }}
      {...props}
    >
      <Row style={{ minHeight: '17rem' }}>
        <Col span={24}>
          <Row style={{ marginBottom: '0.9rem' }}>
            <Skeleton paragraph={false} styles={{ title: { height: '1.9rem', margin: 0 } }} active />
          </Row>
          <Row style={{ marginBottom: '0.5rem' }}>
            <Skeleton paragraph={false} styles={{ title: { height: '1.8rem', margin: 0 } }} active />
          </Row>
          <Row gutter={5} wrap={false} style={{ marginBottom: '0.2rem' }}>
            {Array(5).fill(null).map((_, idx) => {
              return (
                <Col key={idx}>
                  <Skeleton paragraph={false} styles={{ title: { height: '1.3rem', width: '1.3rem', margin: 0 } }} active />
                </Col>
              )
            })}
          </Row>
          <Row>
            <Skeleton paragraph={false} styles={{ title: { height: '2rem', width: '18rem', margin: 0 } }} active />
          </Row>
        </Col>
        <Col style={{ alignSelf: 'end' }} span={24}>
          <Row justify="end" style={{ marginBottom: '0.2rem' }}>
            <Col>
              <Skeleton paragraph={false} styles={{ title: { height: '1.5rem', width: '7rem', margin: 0 } }} active />
            </Col>
          </Row>
          <Row align="middle" gutter={[10, 10]} justify="end" style={{ marginBottom: '0.4rem' }}>
            <Col>
              <Skeleton paragraph={false} styles={{ title: { height: '1.8rem', width: '10rem', margin: 0 } }} active />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Skeleton.Button
                style={{
                  height: '3.5rem'
                }}
                block
                active
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}

export default HotelGoodPriceItemSkeleton